<template>
  <div class="editor">
    <div class="descEditor" ref="editorRef" style="margin-bottom: 20px"></div>
  </div>
</template>

<script>
import E from 'wangeditor';
import axios from 'axios';
import { readFileOfImage, getGradeMinAndMax } from '@/utils/utils';
import { compressPic } from '@/utils/imageHelper';
export default {
  name: 'editor',
  props: {
    zIndex: {
      type: Number,
      default: 500
    }
  },
  data() {
    return {
      editor: null,
      UploadUrl: '',
      uploadToken: '',
      downloadUrl: '',
    }
  },
  created() {

  },
  mounted() {
    this.initE()
  },
  methods: {
    // 上传token
    async getUploadtoken() {
      return new Promise((resolve, reject) => {
        this.$http.getUploadtoken().then(res => {
          this.uploadToken = res.message.token;
          this.UploadUrl = res.message.upUrl;
          this.downloadUrl = res.message.downUrl;
          resolve(res);
        });
      });
    },
    async initE() {
      return new Promise(async (resolve, reject) => {

        this.editor = new E(this.$refs.editorRef);
        // 这里各位小伙伴可以查询官网，根据自己的需求进行菜单栏调整
        this.editor.config.menus = [
          'head',
          'bold',
          'fontSize',
          'fontName',
          'italic',
          'underline',
          'strikeThrough',
          'indent',
          'lineHeight',
          'foreColor',
          'backColor',
          'link',
          'list',
          'todo',
          'justify',
          'quote',
          'emoticon',
          'image',

          'table',
          'code',
          'splitLine',
          'undo',
          'redo',
        ];
        this.editor.config.zIndex = this.zIndex
        this.editor.config.showLinkImg = false
        this.editor.config.height = 500
        this.editor.config.customUploadImg = async (resultFiles, insertImgFn) => {
          await this.getUploadtoken()
          resultFiles.forEach(item => {
            this.uploadImg(item).then(resId => {
              insertImgFn(this.downloadUrl + '?fileId=' + resId)
            })
          })
        }
        this.editor.create();
        this.$emit('on-create')
        resolve()
      })
    },
    // 上传图片
    async uploadImg(ev) {
      return new Promise(async (resolve, reject) => {
        const file = ev;
        const formData = new FormData();
        formData.append('token', this.uploadToken);
        formData.append('file', file);
        const token = localStorage.getItem('loginToken');
        this.source = axios.CancelToken.source();
        var configs = {
          // 上传文件 请求头要设置成下面这样
          headers: {
            token: token,
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          onUploadProgress: progressEvent => {
            if (progressEvent.lengthComputable) {
              const val = (
                (progressEvent.loaded / progressEvent.total) *
                100
              ).toFixed(0);
              // this.uploadPersent = parseInt(val);
            }
          },
          cancelToken: this.source.token
        };

        axios
          .post(this.UploadUrl, formData, configs)
          .then(res => {
            if (res.data.status === 200) {
              const id = res.data.message.fileId;

              resolve(id);
            } else {
              this.$Spin.hide();
              reject(res.data.error);
              this.$Message.warning(res.data.error);
            }
          })
          .catch(err => {
            if (err.message) {
              this.$Message.error(err.message);
            }
          })
          .finally(() => { });
      });
    },
    setEditorContext(html) {
      this.editor.txt.html(html)
    },
    getEditorContext() {
      return this.editor.txt.html()
    }
  }
}
</script>

<style>
</style>